var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadedDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9146_77820)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9146_77820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 22.1693V5.83594C4.6665 3.90277 6.23334 2.33594 8.1665 2.33594H15.0905C15.8862 2.33594 16.6492 2.65201 17.2119 3.21462L22.4545 8.45726C23.0171 9.01987 23.3332 9.78293 23.3332 10.5786V22.1693C23.3332 24.1024 21.7663 25.6693 19.8332 25.6693H8.1665C6.23334 25.6693 4.6665 24.1024 4.6665 22.1693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 2.83594H15.0903C15.7533 2.83594 16.3891 3.09958 16.8579 3.56836L22.1011 8.81055C22.5698 9.27928 22.8334 9.91525 22.8335 10.5781V22.1689C22.8335 23.8259 21.4904 25.1688 19.8335 25.1689H8.1665C6.50948 25.1689 5.1665 23.826 5.1665 22.1689V5.83594C5.1665 4.17891 6.50948 2.83594 8.1665 2.83594Z",
    stroke: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 13.4141,
    width: 9.33333,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 16.3359,
    width: 9.33333,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33325,
    y: 19.25,
    width: 4.66667,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.3335,
    y: 8.16406,
    width: 4.66667,
    height: 1.16667,
    rx: 0.583333,
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9146_77820",
    x: 3.6665,
    y: 2.33594,
    width: 20.6667,
    height: 25.3359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9146_77820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9146_77820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_77820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedDocument);
export default __webpack_public_path__ + "static/media/uploaded-document.3cc8381fa4baa0e2b2078f3a5d63905b.svg";
export { ForwardRef as ReactComponent };